// Renders when all checks have reached a terminal state and at least one required check has failed
// It will show only failing required checks - this is a subset of the checks shown in the full mergebox
// This is done to surface the most actionable information to the user distinctly from the full list of checks shown in the CompletedChecks item
export function FailingChecks() {
  // Placeholder
  return null
}
